<section class="card">
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.yearCalendar' | translate }}
    </h3>
  </div>
  <div class="card-body">
    <form
      [formGroup]="form"
      (ngSubmit)="onFormSubmit()"
      [canEdit]="[accessRights.MetaOption_write]"
      [canEdit]="[accessRights.Settings_write]"
    >
      <p>
        {{ 'configurationOptionModule.yearCalendarInfoText' | translate }}
      </p>

      <div class="row justify-content-between">
        <div class="col-md-3">
          <ng-select
            [items]="years"
            bindLabel="name"
            formControlName="years"
            [(ngModel)]="selectedYear"
          >
          </ng-select>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="form.controls.years.dirty && form.controls.years.invalid"
          >
            {{ 'general.isRequired' | translate }}
          </p>
        </div>
        <div class="col-auto">
          <button class="btn btn-primary" type="submit">
            {{ 'general.save' | translate }}
          </button>
        </div>
      </div>

      <div class="mt-3">
        <div>
          <span class="legend-indicator bg-danger"></span>
          {{ 'general.unavailable' | translate }}
        </div>
        <year-calendar
          [originalCalendar$]="sendCalendar$.asObservable()"
          [getDataFromCalendar$]="getDataFromCalendar$.asObservable()"
          (onSelectedDates)="transformData($event)"
          [year$]="sendselectedYear$.asObservable()"
        ></year-calendar>
      </div>
    </form>
  </div>
</section>
